/**
 * Filtro «Por confirmar» da revisão do import (#474, revisão UX — pedido na
 * orientação UX da #299): num Menu longo, o dono não devia procurar os selos
 * à mão. Toggle que deixa a lista só com os produtos/variantes que precisam
 * de preço. A decisão de «precisa» é a mesma do commit e do selo (UX r3,
 * pontos 2/3): preço EFETIVO <= 0 — no prato, o base derivado das variantes
 * (mínimo das disponíveis); em qualquer variante, o próprio price_cents.
 */
import type { ImportDraftProduct } from '../lib/api.js'
import { useI18n } from '../lib/i18n.js'
import { needsPriceConfirm } from './ImportReviewPriceBadge.js'

/** O produto (ou alguma das suas variantes) precisa de preço? (pura) */
export function productNeedsPriceConfirm(p: ImportDraftProduct): boolean {
  return needsPriceConfirm(p) || p.variants.some((v) => needsPriceConfirm(v))
}

export function ImportReviewPriceFilter({
  active,
  count,
  onToggle,
}: {
  active: boolean
  count: number
  onToggle: () => void
}) {
  const { t } = useI18n()
  return (
    <button
      type="button"
      data-testid="import-review-price-filter"
      aria-pressed={active}
      onClick={onToggle}
      className={`rounded-full text-xs px-3 min-h-11 border ${
        active
          ? 'bg-amber-500 border-amber-500 text-pratzu-aubergine'
          : 'bg-white border-gray-200 text-gray-600 hover:bg-amber-50'
      }`}
    >
      <span aria-hidden="true">⚠</span> {t('admin.import.price_filter')}
      {count > 0 ? ` (${count})` : ''}
    </button>
  )
}
